import * as React from 'react';
import { generatePath, Link } from 'react-router-dom';

import { useRegion } from 'common/hooks/region';
import { isPageSupported } from 'constants/pages';
import { SingularMenuItem } from '../../../utils/menus';
import { ItemIcon } from './ItemIcon';

interface Props {
  item: SingularMenuItem;
  onClose: () => void;
}

export const MenuDropdownItem: React.FC<Props> = (props) => {
  const region = useRegion();

  const { item, onClose } = props;
  const { details } = item.page;

  const disabled = !isPageSupported(item.page, region);

  const to = generatePath(item.page.path, { region: region.route });

  return (
    <li
      key={item.page.title}
      onClick={onClose}
      className={`w-full hover:bg-${details?.hoverColor} my-2 ${
        disabled ? 'pointer-events-none' : ''
      }`}
    >
      <Link to={to} className="w-full">
        <div className="px-4 py-1 flex space-x-4">
          <ItemIcon page={item.page} disabled={disabled} />
          <div className="space-y-1">
            <h4 className={`font-bold ${disabled ? 'text-gray-400' : 'text-gray-900'}`}>
              {item.page.title}
              {`${disabled ? ' (only in LA/LB)' : ''}`}
            </h4>
            {details?.description && (
              <h5 className={`${disabled ? 'text-gray-400' : 'text-gray-600'}`}>
                {details.description(region)}
              </h5>
            )}
          </div>
        </div>
      </Link>
    </li>
  );
};
MenuDropdownItem.displayName = 'DesktopNav.MenuDropdown.Item';
